import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  accountsDeletionPaper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    margin: '0px',
    padding: '24px',
    gap: '45px',
    width: '100%',
    borderRadius: '0px',
    '@media (min-width: 640px)': {
      borderRadius: '4px',
      margin: '16px 24px 16px 24px',
      width: 'auto',
    },
  },
  faqsContainer: {
    display: 'flex',
    gap: '24px',
    maxWidth: '800px',
  },
  faqElement: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  faqQuestionText: {
    fontSize: '16px',
    fontWeight: '600',
    color: theme.evPalette.ocean[800],
  },
  faqAnswerText: {
    fontSize: '16px',
    fontWeight: '400',
    color: theme.evPalette.ocean[800],
    textAlign: 'justify',
  },
  supportText: {
    fontSize: '14px',
    fontWeight: '400',
  },
  linkText: {
    color: theme.evPalette.ocean[500],
    textDecoration: 'none',
  },
  deleteButton: {
    boxShadow: 'none',
    width: 'max-content',
    textTransform: 'none',
    '@media (max-width: 640px)': {
      width: '100%',
    },
  },

}));
